import React from 'react';
import { Avatar, Typography, Tag, Skeleton } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import type { Mentor } from '../../../models/Mentor';

const { Title, Text } = Typography;

interface MentorProfileStepProps {
    mentor: Mentor;
    loading?: boolean;
}

const MentorProfileStep: React.FC<MentorProfileStepProps> = ({ mentor, loading = false }) => {
    if (loading) {
        return (
            <div className="space-y-4">
                <div className="flex items-center space-x-4">
                    <Skeleton.Avatar size={64} active />
                    <div className="flex-1">
                        <Skeleton.Input style={{ width: 200 }} active />
                        <Skeleton.Input style={{ width: 300 }} active />
                    </div>
                </div>
                <div>
                    <Skeleton.Input style={{ width: 100 }} active />
                    <div className="mt-2">
                        <Skeleton.Input style={{ width: '100%' }} active />
                    </div>
                </div>
                <div>
                    <Skeleton.Input style={{ width: 100 }} active />
                    <Skeleton.Input style={{ width: 150 }} active />
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex items-center space-x-4">
                <Avatar size={64} src={mentor.user.profile_pic_url} icon={<UserOutlined />} />
                <div>
                    <Title level={4}>{mentor.user.name || mentor.user.username}</Title>
                    <Text type="secondary">{mentor.description}</Text>
                </div>
            </div>
        </div>
    );
};

export default MentorProfileStep; 